import { fetchUser } from "src/api/user";
import { setUser } from "../user";

export function init() {
  return async dispatch => {
    const user = await fetchUser();
    dispatch(setUser(user));
  };
}



// WEBPACK FOOTER //
// ./src/redux/stories/init.ts